<div *ngIf="loading">Chargement...</div>
<div *ngIf="error" class="error">{{ error }}</div>
<table *ngIf="!loading && !error">
  <thead>
    <tr>
      <th>ID</th>
      <th>Nom</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let chimie of chimies">
      <td>{{ chimie.id }}</td>
      <td>{{ chimie.nom }}</td>
      <td>
        <button (click)="editChimie(chimie.id)">Éditer</button>
        <button (click)="deleteChimie(chimie.id)" [disabled]="deletingId === chimie.id">Supprimer</button>
      </td>
    </tr>
  </tbody>
</table>

